import {ArticleConfigurationTargetMarket} from "@core/shared/models/article/article-configuration";

export const ARTICLE_CONFIGURATION_TARGET_MARKETS: ArticleConfigurationTargetMarket[] = [
    'FRANCE',
    'INTERNATIONAL'
];
